<div class="w-full bg-white rounded-lg shadow dark:border dark:bg-zinc-900 dark:border-zinc-800">
  <div class="p-6 space-y-4 md:space-y-6 sm:p-8">
    <h1 class="text-xl font-semibold leading-tight tracking-tight text-zinc-900 md:text-2xl dark:text-white">
      Entrar
    </h1>
    <p class="text-sm text-zinc-500">
      Escolha como deseja acessar sua conta. Você pode usar suas credenciais ou receber um código por SMS.
    </p>

    <div class="login-modes mt-6">
      <button
        type="button"
        class="login-mode"
        [class.is-active]="activeMode() === 'email'"
        (click)="setMode('email')"
      >
        <i class="fa-regular fa-envelope"></i>
        Email e senha
      </button>
      <button
        type="button"
        class="login-mode"
        [class.is-active]="activeMode() === 'phone'"
        (click)="setMode('phone')"
      >
        <i class="fa-solid fa-mobile-screen-button"></i>
        Telefone
      </button>
    </div>

    @if (activeMode() === 'email') {
      <form class="space-y-8 md:space-y-8 mt-10" [formGroup]="emailForm" (submit)="submitEmail(emailForm)">
        <div class="w-full">
          <p-floatlabel>
            <input
              pInputText
              id="email"
              formControlName="email"
              fluid
              autocomplete="off"
              [invalid]="email.dirty && email.errors"
            />
            <label for="email">Seu email</label>
          </p-floatlabel>
          @if (email.dirty && email.hasError('required')) {
            <p-message severity="error" variant="simple" size="small">Email é obrigatório</p-message>
          } @else if (email.dirty && email.hasError('email')) {
            <p-message severity="error" variant="simple" size="small">Por favor insira um email válido</p-message>
          }
        </div>
        <div class="w-full">
          <p-floatlabel>
            <p-password
              type="password"
              inputId="password"
              formControlName="password"
              fluid
              [invalid]="password.dirty && password.errors"
              [toggleMask]="true"
              [minlength]="8"
              [maxlength]="64"
              [feedback]="false"
            />
            <label for="password">Senha</label>
          </p-floatlabel>
          @if (password.dirty && password.hasError('required')) {
            <p-message severity="error" variant="simple" size="small">Senha é obrigatória</p-message>
          }
        </div>
        <div class="flex items-center justify-end">
          <a href="#" class="text-sm font-medium text-primary-600 hover:underline dark:text-primary-500" (click)="recoverPassword(); $event.preventDefault()">Esqueceu sua senha?</a>
        </div>
        <p-button
          type="submit"
          class="font-medium"
          fluid
          [loading]="(loading$ | async) || false"
        >
          Entrar
        </p-button>
      </form>
    } @else {
      <form class="space-y-6 mt-10" [formGroup]="phoneForm" (submit)="submitPhone()">
        <div class="w-full">
          <p-floatlabel>
            <p-inputmask
              inputId="phone"
              formControlName="phone"
              mask="(99) 99999-9999"
              autocomplete="tel"
              [invalid]="phone.dirty && phone.errors"
              fluid
            />
            <label for="phone">Seu telefone</label>
          </p-floatlabel>

          @if (phone.dirty && phone.hasError('required')) {
            <p-message severity="error" variant="simple" size="small">Telefone é obrigatório</p-message>
          }

          @if (requestingPhoneCode() && !phoneCodeSent()) {
            <div class="mt-3 flex items-center gap-2 text-sm text-zinc-500">
              <i class="fa-solid fa-spinner fa-spin"></i>
              <span>Enviando código de acesso...</span>
            </div>
          }
        </div>

        @if (phoneCodeSent()) {
          <div class="phone-status-card">
            <div class="phone-status-icon">
              <i class="fa-solid fa-circle-check"></i>
            </div>
            <div class="space-y-1">
              <div class="font-semibold text-zinc-900">Código enviado</div>
              <p class="text-sm text-zinc-600">
                Enviamos um código de 6 dígitos para {{ phoneCodeSentTo() }}. Ele expira em até 5 minutos.
              </p>
            </div>
          </div>
        }

        <div class="grid grid-cols-1 md:grid-cols-[minmax(0,1fr)_auto] gap-3 items-start">
          <div class="w-full">
            <p-floatlabel>
              <input
                pInputText
                id="phone_code"
                formControlName="code"
                fluid
                maxlength="6"
                inputmode="numeric"
                autocomplete="one-time-code"
                class="phone-code-input"
                [disabled]="!phoneCodeSent()"
                [invalid]="code.dirty && code.errors"
              />
              <label for="phone_code">Código de acesso</label>
            </p-floatlabel>

            @if (code.dirty && code.hasError('required')) {
              <p-message severity="error" variant="simple" size="small">Código é obrigatório</p-message>
            } @else if (code.dirty && code.hasError('pattern')) {
              <p-message severity="error" variant="simple" size="small">Informe um código válido de 6 dígitos</p-message>
            }
          </div>

          <p-button
            type="button"
            severity="secondary"
            [outlined]="true"
            [label]="getResendLabel()"
            [disabled]="!canRequestPhoneCode() || resendCountdown() > 0 || requestingPhoneCode()"
            [loading]="requestingPhoneCode()"
            (onClick)="resendPhoneCode()"
          />
        </div>

        @if (resendCountdown() > 0) {
          <div class="flex items-center justify-end text-xs text-zinc-500 gap-2">
            <i class="fa-regular fa-clock"></i>
            <span>Reenvio liberado em {{ resendCountdown() }}s</span>
          </div>
        }

        <div class="flex items-center gap-2 text-sm text-zinc-500">
          <i class="fa-solid fa-paper-plane text-xs text-red-500"></i>
          <span>Ao completar o telefone, enviamos o código automaticamente por SMS.</span>
        </div>

        <p-button
          type="submit"
          class="font-medium"
          fluid
          [loading]="validatingPhoneLogin()"
          [disabled]="!phoneCodeSent()"
        >
          Entrar com código
        </p-button>
      </form>
    }
  </div>
</div>
